// extracted by mini-css-extract-plugin
export default {"container":"jl-z","title":"kl-z","linkContainer":"ll-z","viewItemLink":"ml-z"};